import { combineSlices } from "@reduxjs/toolkit";
import { lookAndFeelSlice, privacySlice, tycSlice } from "./slices";

const appSlice = combineSlices( lookAndFeelSlice, privacySlice, tycSlice);

export default appSlice;
